import { render, staticRenderFns } from "./abnormal_user_stat.vue?vue&type=template&id=62a891fd&scoped=true&"
import script from "./abnormal_user_stat.vue?vue&type=script&lang=js&"
export * from "./abnormal_user_stat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a891fd",
  null
  
)

export default component.exports